import { ServerEnv } from 'Configs/ServerEnv'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'

import { proxiedPost } from 'Services/apiClient'

const HydraOrderTerms = (data, token) => {
    return proxiedPost(`${ServerEnv.Hydra()}/orderTerms`, data, {
        config: {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${token}`,
                'X-Application': `asia.fg.${storeCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const HydraCreateCustomer = data =>
    proxiedPost(`${ServerEnv.Hydra()}/customers`, data, {
        config: {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Application': `asia.fg.${storeCountry.Country2().toLowerCase()}`
            }
        }
    })

export const HydraAPIs = {
    HydraOrderTerms,
    HydraCreateCustomer
}
